/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_Start_PastInputs */



/**
* | output |
* | --- |
* | "The term cannot start before today." |
*
* @param {Partner_Add_Customer_Contract_Start_PastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_start_past = /** @type {((inputs?: Partner_Add_Customer_Contract_Start_PastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_Start_PastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Laufzeit kann nicht vor heute beginnen.")
	return /** @type {LocalizedString} */ ("The term cannot start before today.")
});